module.exports = __webpack_public_path__ + "static/media/Cactus_IndigoFair-06.e7f716e2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/illustrations/Cactus_IndigoFair-06.png
 ** module id = 464
 ** module chunks = 0
 **/